import { render, staticRenderFns } from "./PrivacyPizzaMaster.vue?vue&type=template&id=776ce6ce&scoped=true"
import script from "./PrivacyPizzaMaster.vue?vue&type=script&lang=js"
export * from "./PrivacyPizzaMaster.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPizzaMaster.vue?vue&type=style&index=0&id=776ce6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776ce6ce",
  null
  
)

export default component.exports